import { Directive, HostListener, Input, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { filter, take } from 'rxjs';

import { ScrolltoService } from '@services/scrollto.service';
import { SsrService } from '@services/ssr.service';

@Directive({
  selector: '[app-scrollto]',
})
export class ScrolltoDirective {
  private router = inject(Router);
  private scrolltoService = inject(ScrolltoService);
  private ssrService = inject(SsrService);
  @Input('app-scrollto') scrollto?: string;
  public target: HTMLElement | null = null;

  @HostListener('mousedown', ['$event']) onMouseDown(e: MouseEvent): void {
    if (this.ssrService.isServer()) return;
    const target = e.target as HTMLElement;
    if (target.closest('a[href]')) this.clicked(target);
  }

  clicked(target: HTMLElement): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(take(1))
      .subscribe(() => {
        this.scrollTo(target);
      });
  }

  @HostListener('click', ['$event']) onClick(e: MouseEvent): void {
    if (this.ssrService.isServer()) return;
    const target = e.target as HTMLElement;
    if (target?.closest('a[href]')) return;
    this.scrollTo(target);
  }

  scrollTo(target: HTMLElement | null): void {
    if (!this.scrollto) this.scrollto = target?.closest('[scrollto]')?.getAttribute('scrollto') || undefined;
    this.scrolltoService.scrollTo(this.scrollto);
  }
}
